import { CatalogCategoryTab } from "@pages/Catalogs/BrandItems/BrandItems.types"

/**
 * Compute the parent/child display title for a single catalog category.
 *
 * Catalog category names are only unique within their parent, so tabs and badges show the
 * nearest ancestor alongside the name ("Ovens / Accessories") to disambiguate. Roots — with
 * no ancestors — show the plain name. This fixed one-level form keeps every surface at a
 * predictable depth regardless of how deep the category actually sits.
 */
export function getCategoryTitle(category: { name: string; ancestor_names: string[] }): string {
    const nearestAncestor = category.ancestor_names.at(-1)
    return nearestAncestor ? `${nearestAncestor} / ${category.name}` : category.name
}

/**
 * Compute the parent/child display title for each category tab, keyed by category id.
 */
export function getCategoryTabTitles(categories: CatalogCategoryTab[]): Map<number, string> {
    const titles = new Map<number, string>()
    for (const category of categories) {
        titles.set(category.id, getCategoryTitle(category))
    }
    return titles
}
